// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_1c-1";
export var movingGradient = "_1c-4";
export var movingGradientBlock = "_1c-2";
export var skeleton = "_1c-0";
export var skeletonText = "_1c-3";